import type { NextPageWithLayout } from "../../../_app";

import { useQuery } from "@tanstack/react-query";
import Articles from "@components/category/articles";
import {
    getCategoriesDescription,
    getCategoriesKeyWords,
    resolveURL,
} from "@lib/sharedUtils";
import { GQLCategories, GQLDomains, GQLUrls } from "@gql/types/gql";
import MetaTags from "@components/shared/metaTags";
import CategoryTemplate from "@components/category/categoryTemplate";
import initialCall, { initialCallPaths } from "@helpers/initial-call";
import { GetStaticPropsContext } from "next";
import { PLACE_HOLDER_IMAGE_PATH } from "@lib/sharedUtils";
import {
    ICategoryArticlesPageProps,
    ICustomDomain,
    TranslationsObject,
} from "@genericTypes/sharedTypes";
import { translate } from "@helpers/translationObjectFormatter";

const Page: NextPageWithLayout = function Pg() {
    const { data: props } = useQuery<ICategoryArticlesPageProps, Error>([
        "articlesPageProps",
    ]);
    const { category } = props ?? {};
    const { data: domainInfo } = useQuery<ICustomDomain, Error>({
        queryKey: ["domain"],
    });
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    return (
        <>
            <MetaTags
                title={`${
                    (category?.label as string) ?? (category?.name as string)
                } ${translate(
                    translations,
                    "several_general_newsWord",
                )} | Several.com`}
                image={
                    (category?.mainImage?.fullPath as string) ??
                    PLACE_HOLDER_IMAGE_PATH
                }
                description={
                    getCategoriesDescription(
                        category as GQLCategories,
                        domainInfo?.domain as GQLDomains,
                        translate(
                            translations,
                            "several_general_meta_description",
                        ),
                    ) as string
                }
                keyWords={
                    getCategoriesKeyWords(
                        category as GQLCategories,
                        domainInfo?.domain as GQLDomains,
                    ) as string
                }
                url={`${resolveURL(category?.url as GQLUrls)}/news-articles`}
            />
            <CategoryTemplate>
                <Articles />
            </CategoryTemplate>
        </>
    );
};

export function getStaticPaths() {
    return initialCallPaths();
}
export async function getStaticProps(ctx: GetStaticPropsContext) {
    return await initialCall("NewsById", ctx);
}
export default Page;
